module.exports = __webpack_public_path__ + "static/media/termite_case.5b43dac4.obj";


//////////////////
// WEBPACK FOOTER
// ./src/models/termite_case.obj
// module id = 190
// module chunks = 0